export const tabletBreakpoint = '768px';
export const currentTenantLocalStorageKey = 'currentTenant';
